import React, { useState } from "react";
import "../../../pages/signin/sigin.css"
import { useAuth } from "../../../context/AuthContext";

const ForgotPasswordModal = ({ onClose }) => {
    const { sendResetCode, verifyResetCode, resetPassword } = useAuth();
    const [forgotStep, setForgotStep] = useState(1);
    const [forgotEmail, setForgotEmail] = useState("");
    const [resetCode, setResetCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [infoMessage, setInfoMessage] = useState("");

    const handleSendCode = async () => {
        setInfoMessage("");

        if (!forgotEmail.trim()) {
            setInfoMessage("Please enter your email");
            return;
        }

        const res = await sendResetCode(forgotEmail);

        
        if (!res || res.success !== true) {
            setInfoMessage(res?.error || "Failed to send reset code");
            return;
        }

        setInfoMessage("✨ Code sent to your email");
        setForgotStep(2); 
    };
    ;

    const handleVerifyCode = async () => {
        setInfoMessage("");

        if (!resetCode.trim()) {
            setInfoMessage("Please enter the code");
            return;
        }

        const res = await verifyResetCode(forgotEmail, resetCode);

        
        if (!res || res.success !== true) {
            setInfoMessage(res?.error || "Invalid or expired code");
            return;
        }

        setForgotStep(3); 
    };


    const handleResetPassword = async () => {
        setInfoMessage("");

        if (!newPassword || !confirmPassword) {
            setInfoMessage("Please fill both fields");
            return;
        }

        if (newPassword !== confirmPassword) {
            setInfoMessage("Passwords do not match");
            return;
        }

        const res = await resetPassword(forgotEmail, resetCode, newPassword);

        
        if (!res || res.success !== true) {
            setInfoMessage(res?.error || "Password reset failed");
            return;
        }

        setInfoMessage("Password reset successful");

        setTimeout(() => {
            onClose();
            setForgotStep(1);
            setInfoMessage("");
        }, 1200);
    };


    return (
        <div
            className="cart-overlay signin-overlay"
            onClick={() => {
                onClose();
                setForgotStep(1);
                setInfoMessage("");
            }}
        >
            <div className="cart-popup signin-popup" onClick={(e) => e.stopPropagation()}>
                {/* HEADER */}
                <div className="cart-header">
                    <h3>
                        {forgotStep === 1 && "Forgot Password"}
                        {forgotStep === 2 && "Verify Code"}
                        {forgotStep === 3 && "Reset Password"}
                    </h3>
                    <span
                        className="close-btn"
                        onClick={() => {
                            onClose();
                            setForgotStep(1);
                            setInfoMessage("");
                        }}
                    >
                        ×
                    </span>
                </div>

                <div style={{ padding: "20px" }}>
                    {/* STEP 1 — EMAIL */}
                    {forgotStep === 1 && (
                        <>
                            <p className="soft-text">
                                Enter your email and we’ll send you a secret code 🌱
                            </p>

                            <input
                                type="email"
                                className="signin-input"
                                placeholder="Email address"
                                value={forgotEmail}
                                onChange={(e) => setForgotEmail(e.target.value)}
                                style={{ marginBottom: "12px" }}
                            />

                            <button className="signin-btn" onClick={handleSendCode}>
                                Send Code
                            </button>
                        </>
                    )}

                    {/* STEP 2 — CODE */}
                    {forgotStep === 2 && (
                        <>
                            <p className="soft-text">
                                Enter the code we whispered to your inbox 💌
                            </p>

                            <div className="signin-input-group">
                                <input
                                    className="signin-input"
                                    placeholder="Enter verification code"
                                    value={resetCode}
                                    onChange={(e) => setResetCode(e.target.value)}
                                />
                            </div>

                            <button className="signin-btn" onClick={handleVerifyCode}>
                                Verify Code
                            </button>
                        </>
                    )}

                    {/* STEP 3 — RESET PASSWORD */}
                    {forgotStep === 3 && (
                        <>
                            <div className="signin-input-group">
                                <input
                                    type="password"
                                    className="signin-input"
                                    placeholder="New password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                            </div>

                            <div className="signin-input-group">
                                <input
                                    type="password"
                                    className="signin-input"
                                    placeholder="Confirm password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                            </div>

                            <button className="signin-btn" onClick={handleResetPassword}>
                                Reset Password
                            </button>
                        </>
                    )}

                    {/* INFO MESSAGE */}
                    {infoMessage && <div className="info-box">{infoMessage}</div>}
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordModal;
